import { useCallback, useEffect, useState } from 'react'

import { HiMiniXMark } from 'react-icons/hi2'
import { FeedbackCard } from './feedbackCard'
import { useIntl } from 'react-intl'

import Feedback from '../../API/Employee/Feedback'
import { LoadingFeedback } from './loadingFeedback'
import Swal from 'sweetalert2'

export function ModalFeedback({ close, categories, target, type, categorySelected = null }) {
	const [selected, setSelected] = useState(categorySelected)
	const [categoryList, setCategoryList] = useState(null)
	const [comments, setComments] = useState(null)

	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const loadData = useCallback(async () => {
		try {
			const response = await Feedback.getCommentsByTarget(target.id)
			const data = Object.keys(response)

			if (!categorySelected) {
				setSelected(data[0])
			}

			setCategoryList(data)
			setComments(response)
		} catch (error) {
			console.error(error)
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		}
	}, [target])

	useEffect(() => {
		loadData()
	}, [loadData])

	return (
		<div className='tw-absolute tw-top-[60px] tw-left-0 tw-w-screen tw-h-[calc(100vh_-_60px)] tw-bg-black/65 tw-backdrop-blur-[3px] tw-p-8 tw-flex tw-justify-end'>
			<div className='tw-h-full tw-w-6/12 tw-bg-white tw-rounded-md'>
				<div className='border-bottom tw-p-4 tw-flex tw-justify-between tw-items-center'>
					{type === 'received' && (
						<h1 className='tw-m-0 tw-p-0 tw-text-base tw-space-x-2'>
							<span className='tw-font-bold'>Feedbacks Recebidos</span>
						</h1>
					)}
					{type === 'sent' && (
						<h1 className='tw-m-0 tw-p-0 tw-text-base tw-space-x-2'>
							<span className='tw-font-bold'>Feedbacks Enviados</span>
							<span className='tw-text-gray-500'>para</span>
							<span className='tw-font-bold tw-text-purple'>{target.name}</span>
						</h1>
					)}
					<button
						onClick={close}
						className='tw-bg-transparent hover:tw-bg-gray-100 tw-h-8 tw-w-8 tw-rounded-full border-0 tw-flex tw-items-center tw-justify-center'
					>
						<HiMiniXMark size={24} className='tw-text-gray-500' />
					</button>
				</div>
				{!categoryList && !comments && (
					<div className='tw-flex tw-items-center tw-justify-center tw-h-full'>
						<LoadingFeedback label='' />
					</div>
				)}
				{categoryList && comments && (
					<>
						<div className='tw-flex tw-gap-2 tw-w-full tw-overflow-x-auto tw-p-2 tw-whitespace-nowrap'>
							{categoryList.map(item => (
								<div
									key={item}
									onClick={() => setSelected(item)}
									className={`tw-rounded-full tw-px-3 tw-py-1 tw-cursor-pointer hover:tw-bg-gray-200 ${
										selected === item ? 'tw-text-white' : 'tw-text-black'
									}`}
									style={{
										border: `1px solid ${categories[item].color}`,
										background: selected === item ? categories[item].color : 'transparent',
									}}
								>
									{categories[item].name[language]}
								</div>
							))}
						</div>
						<div className='tw-p-3 tw-space-y-2 tw-h-[calc(100%_-_130px)]'>
							<h1 className='tw-text-base tw-text-gray-800'>Comentarios</h1>
							{selected && comments[selected].map(item => <FeedbackCard key={item.id} feedback={item} type={type} />)}
						</div>
					</>
				)}
			</div>
		</div>
	)
}
